import React from 'react'

import { ToastProvider } from '@stores/ToastStore'

import AppRouter from '@/router/AppRouter'

const App = () => {
    return (
        <ToastProvider>
            <AppRouter />
        </ToastProvider>
    )
}

export default App
